import * as ActionTypes from '../constants/ActionType'

export const serviceworkerUpdateFound = () => {
  return {
    type: ActionTypes.SERVICEWORKER_UPDATE_FOUND,
  }
}
